import {
    React, FC, cx, CSSObject, useState, useDeviceSize, useMemo,
} from '@common'
import { media, colors } from '@theme'

import { hydrateOrRender, PanelRendererT } from '../lib/render'

import styled from '@emotion/styled'
import { useDebugScreenshots } from './screenshots/debug-loader'
import { Img } from './screenshots/img'
import { Messages } from './screenshots/message-box'
import { DeviceSizes, ScreenshotsProps, DeviceSize } from './screenshots/types'
import { SizeControls } from './screenshots/size-controls'
import { useEffect } from 'react'

const NavbarDisplay:CSSObject = {
    display: 'block',
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
}

const Navbar = styled.img({
    display: 'none',
    '.mobile &': NavbarDisplay,
    [media.mobile]: {
        ...NavbarDisplay
    },
    '.desktop &': { display: 'none' },
    '.tablet &': { display: 'none' },
})



const ImgContainer = styled.div({
    // '.mobile &': MobileSSStyle,
    // '.tablet &': TabletSSStyle,
    // '.desktop &': DesktopSSStyle,
    // [media.mobile]: {
    //     ...MobileSSStyle,
    //     '.tablet &': TabletSSStyle,
    //     '.desktop &': DesktopSSStyle,
    // },
    // [media.tablet]: {
    //     ...TabletSSStyle,
    //     '.mobile &': MobileSSStyle,
    //     '.desktop &': DesktopSSStyle,
    // },
    // [media.desktop]: {
    //     ...DesktopSSStyle,
    //     '.mobile &': MobileSSStyle,
    //     '.tablet &': TabletSSStyle,
    // },
})

const ScrollContainer=styled.div({
    overflow: 'auto',
    height: '100%',
})

const Figure = styled.figure({
    margin: 0,
    borderRadius: '6px',
    gridArea: 'c',
    justifySelf: 'center',
    position: 'relative',
    overflow: 'hidden',
    maxHeight: '70vh',
    minHeight: 200, // needed so that very short screenshots don't collapse
    '&.bordered': {
        border: `3px solid ${colors.gray5}`,
    },
    '.mobile &': {
        minHeight: 350,
    },
    [media.mobile]: {
        minHeight: 350,
    },
    [media.desktop]: {
        '.mobile &': {
            maxWidth: '50vw',
        },
        '.tablet &': {
            maxWidth: '70vw',
        },
    }
})


const Grid = styled.div({
    aspectRatio: '4 / 3',
    // [media.tablet]: {
    //     aspectRatio: '9 / 12',
    // },
    [media.mobile]: {
        aspectRatio: '9 / 13',
        // '&.desktop': {
        //     aspectRatio: '4/3',
        // },
    },
    display: 'grid',
    position: 'relative',
    gridTemplateAreas: `
        "tl tl tc tr tr"
        "l  c  c  c  r"
        "l cb cb cb  r"
        "bl bl bc br br";
     `,
     gridTemplateRows: '1fr auto auto 1fr',
})



export const Screenshots:FC<ScreenshotsProps> = (props) => {
    const debugProps = useDebugScreenshots(props)

    const { name, messages, caption, border, withNavbar, sizes = DeviceSizes } = debugProps || props

    const deviceSize = useDeviceSize()

    const [display, _setDisplay] = useState<DeviceSize | null>(sizes.length === 1 ? sizes[0] : null)
    const [targetRef, setTargetRef] = useState<HTMLDivElement | null>(null)
    useEffect(() => {
        if (!sizes.includes(deviceSize)) _setDisplay(sizes[0])
    }, [sizes, deviceSize])
    const dataProps = useMemo(() =>
        JSON.stringify({ name, messages, caption, withNavbar, border, sizes }),
        [name, messages, caption, withNavbar, border, sizes]
    )

    const displaySize = display || (!sizes?.includes(deviceSize) ? sizes?.[0] : deviceSize) || sizes[0]

    const setDisplay = React.useCallback((ev: React.MouseEvent<HTMLAnchorElement>) => {
        ev.preventDefault()
        _setDisplay(ev.currentTarget.dataset?.size as DeviceSize|| null)
    }, [_setDisplay])

    return (
        <Grid className={cx('screenshots my-2', display)} data-props={dataProps}>
            <Figure className={cx({ bordered: !!border })}>
                <ScrollContainer>
                    <ImgContainer ref={setTargetRef}>
                        {sizes.map(s => (
                            <Img
                                key={String(s)}
                                className={s}
                                alt={`${s} ${name} screenshot`}
                                src={`/screenshots/${name}-${s}.png`}
                            />))}
                    </ImgContainer>
                </ScrollContainer>
                {withNavbar && <Navbar src={`/screenshots/${name}-mobile-nav.png`} />}
            </Figure>
            <SizeControls setDisplay={setDisplay} sizes={sizes} />

            <Messages sizes={sizes} messages={messages} deviceSize={deviceSize} displaySize={displaySize} target={targetRef} />
        </Grid>
    )
}

const renderer: PanelRendererT = (options) => {
    const props = JSON.parse(options.panel.querySelector<HTMLDivElement>('[data-props]')?.dataset?.props || '{}')
    hydrateOrRender({ Component: Screenshots, ...options, ...props })
}

export default renderer

